import {
  FETCH_TENANT_REQUEST,
  FETCH_TENANT_SUCCESS,
  FETCH_TENANT_FAILURE,
  FETCH_TENANT_DETAIL_REQUEST,
  FETCH_TENANT_DETAIL_SUCCESS,
  FETCH_TENANT_DETAIL_FAILURE,
  CLEAR_STORE,
  UPDATE_TENANT_DETAIL_REQUEST,
  UPDATE_TENANT_DETAIL_SUCCESS,
  UPDATE_TENANT_DETAIL_FAILURE,
} from './tenantActions';

export interface TenantState {
  loading: boolean;
  tenant: any;
  error: string | null;
  tenant_details: any;
}

const initialState: TenantState = {
  loading: true,
  tenant: null,
  error: null,
  tenant_details: null,
};

interface TenantAction {
  type: string;
  payload?: any;
  error?: any;
}

const tenantReducer = (
  state: TenantState = initialState,
  action: TenantAction,
): TenantState => {
  switch (action.type) {
    case FETCH_TENANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        tenant: action.payload,
      };
    case FETCH_TENANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case FETCH_TENANT_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TENANT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        tenant_details: action.payload,
      };
    case FETCH_TENANT_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case UPDATE_TENANT_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_TENANT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        tenant_details: action.payload,
      };
    case UPDATE_TENANT_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export default tenantReducer;

